module.exports = __webpack_public_path__ + "static/media/Portraits Over Gchat Ch. 1.3dcf6b1c.jpg";